"use strict";

import { AMPLITUDE_EVENTS } from "../../amplitude";

import commonBondViewTemplate from "./CommonBondViewTemplate";
import studentLoanEvents from "./events/StudentLoanEvents";

const CommonBondDirective = function (
    $location,
    $window,
    $modal,
    samlTokenService,
    paeService,
    eventBus,
    $translate
) {
    return {
        restrict: "E",
        scope: {
            factoryName: "@",
            //uniqueId is the string to append to the form id
            uniqueId: "@"
        },
        template: commonBondViewTemplate,
        controller: [
            "$scope",
            "$rootScope",
            function ($scope, $rootScope) {
                $scope.continueClick = function () {
                    if (!$scope.isPae) {
                        eventBus.dispatch(studentLoanEvents.CONTINUE_CLICKED, this);
                        eventBus.dispatchAmplitude({
                            event_type: AMPLITUDE_EVENTS.SELECT_BUTTON,
                            event_properties: {
                                selection: studentLoanEvents.CONTINUE_CLICKED
                            }
                        });
                        const ssoWindow = window.window;
                        samlTokenService.navigateToken("Candidly", ssoWindow, $scope.uniqueId);
                    } else {
                        $window.location.href = "/participant/accounts/#/accessDeniedError/44403";
                    }
                };
                $scope.dismiss = function () {
                    eventBus.dispatch(studentLoanEvents.CANCEL_CLICKED, this);
                    eventBus.dispatchAmplitude({
                        event_type: AMPLITUDE_EVENTS.SELECT_BUTTON,
                        event_properties: {
                            selection: studentLoanEvents.CANCEL_CLICKED
                        }
                    });
                    window.close();
                };

                $rootScope.$on("$translateChangeSuccess", function () {
                    $scope.translations = {
                        empowerPolicyLink: $translate.instant(
                            "accountList.commonBond.empowerPolicyLink"
                        ),
                        commonBondPolicyLink: $translate.instant(
                            "accountList.commonBond.commonBondPolicyLink"
                        ),
                        empowerCommonbondTermsPDF: $translate.instant(
                            "accountList.commonBond.empowerCommonbondTermsPDF"
                        ),
                        defaultCommonBondFlag: $translate.instant(
                            "accountList.commonBond.defaultCommonBondFlag"
                        )
                    };
                });
            }
        ],

        link: function ($scope, element, attrs) {
            const isPaePromise = paeService.checkPaeUser();
            isPaePromise.then(
                function (pae) {
                    $scope.isPae = pae.partnerSSOResponse;
                },
                function (reason) {
                    $scope.isPae = true;
                }
            );
        }
    };
};
CommonBondDirective.$inject = [
    "$location",
    "$window",
    "$modal",
    "samlTokenService",
    "paeService",
    "eventBus",
    "$translate"
];
export default CommonBondDirective;
